module.exports = __webpack_public_path__ + "static/media/Doug Curtis Headshot_1699256212902.8ca00aa3.png";